<template>
<el-form-item label="发布设置" class='permanent'>
  <quotas-required-dialog ref='quotas-required-dialog' @close='close' />
  <el-radio-group theme='info' v-model='permanent' @change="change">
    <el-radio-button label='temp' v-if="!project.permanent">
      临时
      <span class='sub' v-html="timeDiff(project.expired_at) > 0 ? timeDiff(project.expired_at, true) + '过期' : '<span class=\'danger\'>已过期</span>'">
      </span>
    </el-radio-button>
    <el-radio-button label='permanent'>
      永久
    </el-radio-button>
  </el-radio-group>
</el-form-item>
</template>

<script>
import QuotasRequiredDialog from './permanent/quotas_required.dialog'
export default {
  data() {
    return {
      permanent: null
    }
  },
  components: {
    'quotas-required-dialog': QuotasRequiredDialog
  },
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    }
  },
  methods: {
    change(value) {
      let vm = this
      if (value === 'permanent' && !vm.project.permanent) {
        // check quotas first
        vm.$store.dispatch('quota/index', { force: true }).then(res => {
          if (res.summary.permanents_left === 0) {
            // no data
            vm.$refs['quotas-required-dialog'].open()
          }
        })
      }
    },
    close() {
      let vm = this
      // recheck quota again, and alter to temp if there is no quota getted
      vm.$store.dispatch('quota/index').then(res => {
        if (res.summary.permanents_left === 0) {
          vm.permanent = 'temp'
        }
      })
    },
    save() {
      // handle on parent save
      let vm = this
      return (vm.permanent === 'temp' || vm.project.permanent) ? Promise.resolve() : new Promise((resolve, reject) => {
        // vm.permanent = permanent, and vm.project.permanent = false, try to unlock project
        vm.$store.dispatch('quota/consume', {
          key: 'permanent',
          project_id: vm.project.id
        }).then(resolve).catch(reject)
      })
    }
  },
  mounted() {
    this.permanent = this.project.permanent ? 'permanent' : 'temp'
  }
}
</script>

<style lang='scss' scoped>
.permanent {
    .sub {
        font-size: $font-size-small;
        margin-left: 1em;
        color: $font-color-light;
    }
}
</style>



// WEBPACK FOOTER //
// permanent.card.vue?32c0d41b